import { render, staticRenderFns } from "./modif-positioning-device-fittings-type-modal.vue?vue&type=template&id=08e4c973"
import script from "./modif-positioning-device-fittings-type-modal.vue?vue&type=script&lang=js"
export * from "./modif-positioning-device-fittings-type-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports